// 使用引导页（M4 任务 4.2）· 公开访问：3 分钟上手 + 填写技巧 + FAQ
import { Link } from "react-router-dom";
import { BrandLogo } from "../components/BrandLogo";

const STEPS = [
  {
    t: "① 注册并新建方案",
    d: "用邮箱注册（本地体验版注册即登录）。点「新建方案」，填 5 个字段：",
    tips: [
      "品牌名称：如「茯气」——方案封面就是它；",
      "核心产品：一句话说清卖什么、有何不同，越具体越好（例：把茯苓、山药做成办公室即食零食，0 蔗糖独立小包装）；",
      "目标人群：写到「谁、在什么场景、为什么买」（例：25-35 岁一线城市女性白领，熬夜+养生焦虑）；",
      "营销目标：带数字最好（例：上市 3 个月小红书打透，天猫月销破百万）；",
      "预算量级：可选，写了经营测算会更贴实际。",
    ],
  },
  {
    t: "② 等待 AI 流水线（约 3–8 分钟）",
    d: "提交后自动跳转进度页：资料解析 → 行业调研 → 竞品分析 → 策略制定 → 经营测算 → 大纲 → 文案 → 评审 → 装配，每一步都在页面上实时可见，还附带调研引用来源。生成完毕自动跳到结果页。",
  },
  {
    t: "③ 网页内改稿（可选）",
    d: "点「在线编辑」进入编辑器：",
    tips: [
      "改文字：直接点击画布上的文字，输入即改，800ms 自动保存；",
      "换配图：点击配图位，本地上传或从素材库选；",
      "调页序：左侧缩略图拖拽；支持删页、新增页、撤销/重做（30 步）；",
      "版本快照：改重要版本前点「快照」，随时可回滚到任意历史版本；",
      "演讲备注：每页底部的备注区，导出时会写进 PPT 备注。",
    ],
  },
  {
    t: "④ 导出 .pptx",
    d: "点「导出 PPTX」→ 稍候几秒 → 下载。文件将以方案标题命名（如「茯气：把奶奶的药柜，装进你的抽屉.pptx」），用 PowerPoint 或 WPS 打开继续精修、汇报、打印。",
  },
];

const FAQ = [
  {
    q: "生成要多久？卡住或失败怎么办？",
    a: "正常 3–8 分钟。进度页每 3 秒自动刷新；若某步失败，流水线会自动降级（跳过失败步骤直接出片）并标注。终态失败可在工作台点「重新生成」重跑，不产生额外等待之外的成本。",
  },
  {
    q: "AI 写的内容可以直接用吗？",
    a: "方案是「结构完整、数据有出处的初稿」：调研数据均附引用链接，建议关键数字二次核实；策略与文案部分建议在编辑器里改成你的语气和内部信息后再对外使用。",
  },
  {
    q: "下载的 PPTX 打不开（提示「无法读取」）？",
    a: "这是 Windows 对「网络来源文件」的安全标记（MOTW）导致的，不是文件损坏：右键文件 → 属性 → 勾选底部「解除锁定」→ 确定，即可正常打开。公司网络下载的文件同理。",
  },
  {
    q: "我的资料会被用于 AI 训练吗？",
    a: "不会。资料仅通过企业级 API 发送给大模型用于当次生成，按厂商 API 条款不用于训练。详见《数据安全承诺》。",
  },
  {
    q: "一个项目可以生成几次？",
    a: "不限次数。工作台里每个项目卡片都有「重新生成」，适合改资料后对比不同版本的方案；每次生成的 deck 都会保留。",
  },
];

export default function Guide() {
  return (
    <div className="min-h-screen bg-[#FAF8F4]">
      <header className="flex items-center justify-between border-b border-[#E4DFD5] bg-white px-6 py-3">
        <Link to="/" aria-label="策略咖首页"><BrandLogo /></Link>
        <nav className="flex items-center gap-4 text-sm">
          <Link to="/security" className="text-muted hover:text-ink">数据安全</Link>
          <Link to="/login" className="btn-primary !py-1.5">登录</Link>
        </nav>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-10">
        <h1 className="text-3xl font-bold text-ink">3 分钟上手</h1>
        <p className="mt-2 text-sm text-muted">从注册到导出第一份方案，全程不超过 10 分钟。</p>

        <div className="mt-8 space-y-4">
          {STEPS.map((s) => (
            <section key={s.t} className="card !p-5">
              <h2 className="font-bold text-ink">{s.t}</h2>
              <p className="mt-2 text-sm text-muted">{s.d}</p>
              {s.tips && (
                <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-muted">
                  {s.tips.map((tip) => <li key={tip}>{tip}</li>)}
                </ul>
              )}
            </section>
          ))}
        </div>

        <h2 className="mt-10 text-xl font-bold text-ink">常见问题</h2>
        <div className="mt-4 space-y-3">
          {FAQ.map((f) => (
            <details key={f.q} className="card !p-4">
              <summary className="cursor-pointer font-medium text-ink">{f.q}</summary>
              <p className="mt-2 text-sm text-muted">{f.a}</p>
            </details>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link to="/login" className="btn-primary !px-8 !py-3">现在就开始 →</Link>
        </div>
      </main>
    </div>
  );
}
